export default "__VITE_ASSET__SF1C4cyD__"